import { render, staticRenderFns } from "./certificateBindView.vue?vue&type=template&id=ea1cb9d0&"
import script from "./certificateBindView.vue?vue&type=script&lang=js&"
export * from "./certificateBindView.vue?vue&type=script&lang=js&"
import style0 from "./certificateBindView.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports